import { useFormContext, useWatch } from 'react-hook-form';

import { getSddFulfillmentStatus } from '@libs/shared-ui';

import { type FormFields, usePurchaseFormWatch } from '@/entities/purchase-form';

import { useSddTailoredData } from './useSddTailoredData';

export const useSddDeliveryTile = () => {
    const { product, isLoading, availableStock, streetAddress, isAvailableForPurchaseOption, isDoorDashAvailable } =
        useSddTailoredData();

    const { control, register } = useFormContext<FormFields>();
    const purchaseOption = usePurchaseFormWatch('purchaseOption');
    const autoshipFrequency = usePurchaseFormWatch('autoshipFrequency');
    const selectedDeliveryMethod = useWatch({ control, name: 'fulfilmentMethod' });

    // Disable SDD when "One Time" frequency is selected for autoship
    const isOneTimeFrequencySelected = purchaseOption === 'autoship' && autoshipFrequency === 'one_time';
    const isDisabled = !isLoading && (!isAvailableForPurchaseOption || isOneTimeFrequencySelected);
    const minimumCaseQty = product?.deliveryMethods?.SDD?.purchaseQuantities?.min ?? 1;

    const status = getSddFulfillmentStatus({
        availableStock,
        minimumCaseQty,
        isAvailable: isDoorDashAvailable,
        hasStreetAddress: !!streetAddress,
    });

    return {
        isLoading,
        isDisabled,
        status,
        selectedDeliveryMethod,
        register: register('fulfilmentMethod'),
    };
};
